import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { GET_PRODUCTS } from "../constants/action-types";
const API_CONFIG = getApiConfig();


export const getProductAvailability = (customerId, productId, callback) => dispatch => {
    const fileUrl = `${API_CONFIG.URL}/products/availability?customerID=${customerId}&productID=${productId}&startDate=2017-01-01&endDate=2100-12-01`;
    adalApiFetch(Axios, fileUrl, {
        method: "get",
    }).then(res => {  
        callback(res.data);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error}`);
            callback(null);
        });
};

